
<div class="container scrollable-x" >

  <div class="head">
    <h3>{{"privacy-notice.title" | translate}}</h3>
    <span style="text-align: right">Rev. 01/24</span>
  </div>

  <div class="row mb-1 " >
    <div style="width: 100vw;">
      <p-table [value]="[[]]">
        <ng-template pTemplate="body">
          <tr>
            <td class = "dark_cell">{{"privacy-notice.data-column" | translate}}</td>
            <td class = "dark_cell_data">{{"privacy-notice.what-pathward-does" | translate}}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>

  <div class="row mb-3 " >
    <div style="width: 100vw;">
      <p-table [value]="[[]]" styleClass="p-datatable-gridlines">
        <ng-template pTemplate="body">
          <tr>
            <td class="gray_cell_big">{{"privacy-notice.why" | translate}}</td>
            <td class="data_cell">{{"privacy-notice.why-explanation" | translate}}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>

  <div class="row mb-3 " >
    <div style="width: 100vw;">
      <p-table [value]="[[]]" styleClass="p-datatable-gridlines">
        <ng-template pTemplate="body">
          <tr style="border:1px">
            <td class="gray_cell_big">{{"privacy-notice.what" | translate}}</td>
            <td class="data_cell">
              <p class="mb-2">{{"privacy-notice.what-explanation-intro" | translate}}</p>
              <ul class="mb-2 large-bullets" style="padding-left: 20px !important;">
                <li class="li-who">
                  <span class="data_cell">{{"privacy-notice.social-security-income" | translate}}</span>
                </li>
                <li class="li-who">
                  <span class="data_cell">{{"privacy-notice.account-balances-transactions" | translate}}</span>
                </li>
                <li class="li-who">
                  <span class="data_cell">{{"privacy-notice.credit-history-assets" | translate}}</span>
                </li>
              </ul>
              <p>{{"privacy-notice.what-explanation-outro_1" | translate}}<i>{{"privacy-notice.what-explanation-outro_2" | translate}}</i>{{"privacy-notice.what-explanation-outro_3" | translate}}</p>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>

  <div class="row mb-3 " >
    <div style="width: 100vw;">
      <p-table [value]="[[]]" styleClass="p-datatable-gridlines">
        <ng-template pTemplate="body" >
          <tr>
            <td class="gray_cell_big">{{"privacy-notice.how" | translate}}</td>
            <td class="data_cell">
              <p>{{"privacy-notice.how-explanation" | translate}}</p>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>

  <div class="row mb-3 " >
    <div style="width: 100vw;">
      <p-table [value]="[[]]" styleClass="p-datatable-gridlines">
        <ng-template pTemplate="header">
          <tr>
            <th style="width:350px" class="gray_cell_small">{{"privacy-notice.reasons-share-info" | translate}}</th>
            <th class="gray_cell_small">{{"privacy-notice.pathward-shares" | translate}}</th>
            <th class="gray_cell_small" style=" border: 0px">{{"privacy-notice.can-limit-sharing" | translate}}</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" >
          <tr >
            <td class="data_cell">
              <p style="padding-left: 7px"><b>{{"privacy-notice.daily-business-purposes" | translate}}</b>
                <br>
                {{"privacy-notice.daily-business-purposes-explanation" | translate}}
              </p>
            </td>
            <td class="data_cell">
              <p class="yesno">{{"privacy-notice.yes" | translate}}</p>
            </td>
            <td class="data_cell">
              <p class="yesno">{{"privacy-notice.no" | translate}}</p>
            </td>
          </tr>
          <tr >
            <td class="data_cell" >
              <p style="padding-left: 7px;"><b>{{"privacy-notice.marketing-purposes" | translate}}</b>
                <br>
                {{"privacy-notice.marketing-purposes-explanation" | translate}}
              </p>
            </td>
            <td class="data_cell" >
              <p class="yesno">{{"privacy-notice.yes" | translate}}</p>
            </td>
            <td class="data_cell">
              <p class="yesno">{{"privacy-notice.no" | translate}}</p>
            </td>
          </tr>
          <tr >
            <td class="data_cell" >
              <p style="padding-left: 7px;"><b>{{"privacy-notice.joint-marketing-other-companies" | translate}}</b></p>
            </td>
            <td class="data_cell" >
              <p class="yesno">{{"privacy-notice.yes" | translate}}</p>
            </td>
            <td class="data_cell">
              <p class="yesno">{{"privacy-notice.no" | translate}}</p>
            </td>
          </tr>
          <tr >
            <td class="data_cell" >
              <p style="padding-left: 7px;"><b>{{"privacy-notice.affiliates-daily-business-transactions" | translate}}</b><br> {{"privacy-notice.affiliates-daily-business-transactions-explanation" | translate}}</p>
            </td>
            <td class="data_cell" >
              <p class="yesno">{{"privacy-notice.no" | translate}}</p>
            </td>
            <td class="data_cell">
              <p class="yesno">{{"privacy-notice.not-sharing" | translate}}</p>
            </td>
          </tr>
          <tr >
            <td class="data_cell" >
              <p style="padding-left: 7px;"><b>{{"privacy-notice.affiliates-daily-business-creditworthiness" | translate}}</b><br> {{"privacy-notice.affiliates-daily-business-creditworthiness-explanation" | translate}}</p>
            </td>
            <td class="data_cell" >
              <p class="yesno">{{"privacy-notice.no" | translate}}</p>
            </td>
            <td class="data_cell">
              <p class="yesno">{{"privacy-notice.not-sharing" | translate}}</p>
            </td>
          </tr>
          <tr >
            <td class="data_cell" >
              <p style="padding-left: 7px; font-weight: bold">{{"privacy-notice.affiliates-marketing" | translate}}</p>
            </td>
            <td class="data_cell" >
              <p class="yesno">{{"privacy-notice.no" | translate}}</p>
            </td>
            <td class="data_cell">
              <p class="yesno">{{"privacy-notice.not-sharing" | translate}}</p>
            </td>
          </tr>
          <tr >
            <td class="data_cell" >
              <p style="padding-left: 7px; font-weight: bold">{{"privacy-notice.non-affiliates-marketing" | translate}}</p>
            </td>
            <td class="data_cell" >
              <p class="yesno">{{"privacy-notice.no" | translate}}</p>
            </td>
            <td class="data_cell">
              <p class="yesno">{{"privacy-notice.not-sharing" | translate}}</p>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>

  <div class="row mb-3 " >
    <div style="width: 100vw;">
      <p-table [value]="[[]]" styleClass="p-datatable-gridlines">
        <ng-template pTemplate="body">
          <tr>
            <td class="gray_cell_big" style="vertical-align:middle !important; padding-bottom: 3px; padding-top: 3px !important;">{{"privacy-notice.questions" | translate}}</td>
            <td class="data_cell">{{"privacy-notice.contact-info" | translate}}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
  <div style="margin-top: 1px;">
    <div class="row mb-0" >
      <div style="width: 100vw;">
        <p-table [value]="[[]]" styleClass="p-datatable-gridlines">
          <ng-template pTemplate="body">
            <tr>
              <td class="page2" style="vertical-align:middle !important; padding-bottom: 0px; padding-top: 3px !important;">{{"privacy-notice.page2" | translate}}</td>
              <td class="page2_no_data"> </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>

  <div class="row mb-1 " >
    <div style="width: 100vw;">
      <p-table [value]="[[]]" styleClass="p-datatable-gridlines">
        <ng-template pTemplate="colgroup">
          <colgroup>
            <col  [style.width]="'36%'">
            <col  [style.width]="'64%'">
          </colgroup>
        </ng-template>

        <ng-template pTemplate="header">
          <tr>
            <th colspan="2" class="gray_cell_page2">{{"privacy-notice.who-we-are" | translate}}</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" >
          <tr >
            <td class="data_cell_page2" style="max-width:50px !important; vertical-align: top">
              <p style="padding-left: 7px; font-weight: bold">{{"privacy-notice.who-provides-notice" | translate}}</p>
            </td>
            <td class="data_cell_page2">
              <p style="padding-left: 7px">{{"privacy-notice.who-provides-notice-answer" | translate}}</p>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>

  <div class="row mb-1 " >
    <div style="width: 100vw;">
      <p-table [value]="[[]]" styleClass="p-datatable-gridlines">
        <ng-template pTemplate="colgroup">
          <colgroup>
            <col  [style.width]="'36%'">
            <col  [style.width]="'64%'">
          </colgroup>
        </ng-template>

        <ng-template pTemplate="header">
          <tr>
            <th colspan="2" class="gray_cell_page2">{{"privacy-notice.what-we-do" | translate}}</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" >
          <tr >
            <td class="data_cell_page2" style="max-width:50px !important; vertical-align: top">
              <p style="padding-left: 7px; font-weight: bold">{{"privacy-notice.how-pathward-protects-info" | translate}}</p>
            </td>
            <td class="data_cell_page2">
              <p style="padding-left: 7px">{{"privacy-notice.how-pathward-protects-info-answer" | translate}}</p>
            </td>
          </tr>
          <tr >
            <td class="data_cell_page2" style="max-width:50px !important; vertical-align: top">
              <p style="padding-left: 7px; font-weight: bold">{{"privacy-notice.how-pathward-collects-info" | translate}}</p>
            </td>
            <td class="data_cell_page2">
              <p style="padding-left: 7px">{{"privacy-notice.how-pathward-collects-info-answer-intro" | translate}}</p>
              <ul class="large-bullets">
                <li>
                  <p class="data_cell_page2">{{"privacy-notice.open-account-loan" | translate}}</p>
                </li>
                <li>
                  <p class="data_cell_page2">{{"privacy-notice.deposits-withdrawals-account-info" | translate}}</p>
                </li>
                <li>
                  <p class="data_cell_page2">{{"privacy-notice.electronic-transfer" | translate}}</p>
                </li>
              </ul>
              <p style="padding-left: 7px">{{"privacy-notice.how-pathward-collects-info-answer-outro" | translate}}</p>
            </td>
          </tr>
          <tr>
            <td class="data_cell_page2" style="max-width:50px !important; vertical-align: top">
              <p style="padding-left: 7px; font-weight: bold">{{"privacy-notice.why-cant-limit-all-sharing" | translate}}</p>
            </td>
            <td class="data_cell_page2">
              <p style="padding-left: 7px">{{"privacy-notice.why-cant-limit-all-sharing-answer-intro" | translate}}</p>
              <ul class="large-bullets">
                <li>
                  <p class="data_cell_page2">{{"privacy-notice.affiliates-daily-business-creditworthiness-limit" | translate}}</p>
                </li>
                <li>
                  <p class="data_cell_page2">{{"privacy-notice.affiliates-marketing-limit" | translate}}</p>
                </li>
                <li>
                  <p class="data_cell_page2">{{"privacy-notice.non-affiliates-marketing-limit" | translate}}</p>
                </li>
              </ul>
              <p style="padding-left: 7px">{{"privacy-notice.why-cant-limit-all-sharing-answer-outro" | translate}}</p>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>

  <div class="row mb-1 " >
    <div style="width: 100vw;">
      <p-table [value]="[[]]" styleClass="p-datatable-gridlines">
        <ng-template pTemplate="colgroup">
          <colgroup>
            <col  [style.width]="'36%'">
            <col  [style.width]="'64%'">
          </colgroup>
        </ng-template>

        <ng-template pTemplate="header">
          <tr>
            <th colspan="2" class="gray_cell_page2">{{"privacy-notice.definitions" | translate}}</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" >
          <tr >
            <td class="data_cell_page2" style="max-width:50px !important; vertical-align: top">
              <p style="padding-left: 7px; font-weight: bold">{{"privacy-notice.affiliates" | translate}}</p>
            </td>
            <td class="data_cell_page2">
              <p style="padding-left: 7px">{{"privacy-notice.affiliates-definition" | translate}}</p>
              <ul class="large-bullets">
                <li>
                  <p class="data_cell_page2" style="font-style: italic">{{"privacy-notice.affiliates-pathward-note" | translate}}</p>
                </li>
              </ul>
            </td>
          </tr>
          <tr >
            <td class="data_cell_page2" style="max-width:50px !important; vertical-align: top">
              <p style="padding-left: 7px; font-weight: bold">{{"privacy-notice.non-affiliates" | translate}}</p>
            </td>
            <td class="data_cell_page2">
              <p style="padding-left: 7px">{{"privacy-notice.non-affiliates-definition" | translate}}</p>
              <ul class="large-bullets">
                <li>
                  <p class="data_cell_page2" style="font-style: italic">{{"privacy-notice.non-affiliates-pathward-note" | translate}}</p>
                </li>
              </ul>
            </td>
          </tr>
          <tr >
            <td class="data_cell_page2" style="max-width:50px !important; vertical-align: top">
              <p style="padding-left: 7px; font-weight: bold">{{"privacy-notice.joint-marketing" | translate}}</p>
            </td>
            <td class="data_cell_page2">
              <p style="padding-left: 7px">{{"privacy-notice.joint-marketing-definition" | translate}}</p>
              <ul class="large-bullets">
                <li>
                  <p class="data_cell_page2" style="font-style: italic">{{"privacy-notice.joint-marketing-pathward-note" | translate}}</p>
                </li>
              </ul>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>

  <div class="row mb-1 " >
    <div style="width: 100vw;">
      <p-table [value]="[[]]" styleClass="p-datatable-gridlines">
        <ng-template pTemplate="header">
          <tr>
            <th class="gray_cell_page2">{{"privacy-notice.other-important-information" | translate}}</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" >
          <tr >
            <td class="data_cell_page2" style=" vertical-align: top">
              <p style="padding-left: 7px;"><b>
                {{"privacy-notice.special-notice-state-residents" | translate}}
              </b>
                {{"privacy-notice.special-notice-state-residents-message" | translate}}
              </p>
              <br>
              <p style="padding-left: 7px;"><b>
                {{"privacy-notice.vermont-notice-state-residents" | translate}}
              </b>
                {{"privacy-notice.vermont-notice-state-residents-message" | translate}}
              </p>
              <br>
              <p style="padding-left: 7px;"><b>
                {{"privacy-notice.nevada-notice-state-residents" | translate}}
              </b>
                {{"privacy-notice.nevada-notice-state-residents-message" | translate}}
              </p>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>

</div>

